import { Form, InputNumber, Typography } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'
import { ConfigCard } from './styles'

const FormItem = Form.Item
const { Text } = Typography

const Counter = ({ counter }) => {
	return (
		<ConfigCard title="Contador de documentos">
			<FormItem
				label="Contagem atual"
				name="counter"
				style={{ maxWidth: '40rem' }}
				initialValue={counter}>
				<InputNumber min={0} />
			</FormItem>
			<Text>
				Use a variável <Text code>CONTADOR</Text> para exibir o contador no
				texto ou no título do documento.
			</Text>
		</ConfigCard>
	)
}

Counter.propTypes = {
	counter: PropTypes.number,
}

export default Counter
